import type { FC } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { sendTelemetryEvent } from "@/lib/telemetry";
import { browserStatics } from "@/src/shared/BrowserStatic";
import ButtonV2 from "@Components/Button/ButtonV2";
import { MgmEventType, TelemetryEntity, gotoNativeScreen, urlFormat } from "@Components/Modules/Helpers";
import { scrollToCbBrandsList } from "@Constants/PortalConstants";
import { CashbackDetails } from "@Routes/CashbackLinks";

import * as css from "./MgmPhoneVerification.module.css";

type IMgmPhoneVerificationSuccess = {
    description: string;
    details: string;
    nextButtonText: string;
};

const MgmPhoneVerificationSuccess: FC<IMgmPhoneVerificationSuccess> = ({
    description,
    details,
    nextButtonText,
}) => {
    const navigate = useNavigate();
    const cashbackPageUrl = urlFormat(CashbackDetails, { [scrollToCbBrandsList]: true }, true);

    useEffect(
        () =>
            sendTelemetryEvent({
                eventName: `${TelemetryEntity.Cashback}-${MgmEventType.receiverSuccess}`,
                actionType: "View",
            }),
        [],
    );

    return (
        <div className={css.successScreen}>
            <h3>{description}</h3>
            <p dangerouslySetInnerHTML={{ __html: details }} />
            <ButtonV2
                appearance="magentaRoundAppearance"
                onClick={() => {
                    sendTelemetryEvent({
                        eventName: `${TelemetryEntity.Cashback}-${MgmEventType.receiverSuccess}`,
                        actionType: "Click",
                    });

                    if (browserStatics.isMobileApp) {
                        gotoNativeScreen(cashbackPageUrl);
                        return;
                    }

                    navigate(cashbackPageUrl);
                }}
            >
                {nextButtonText}
            </ButtonV2>
        </div>
    );
};

export default MgmPhoneVerificationSuccess;
